module.exports = __webpack_public_path__ + "static/media/message-tick-error.0d536202.png";